<template>
    <div id="contents">
        <div class="contents_wrap">
            <h2 class="pg_title">Mobile SVC Request Status Detail (Other)</h2>
            <!-- breadcrumbs -->
            <div class="bc_ico">
                Home
                <em>
                    <span class="sr_only">&gt;</span>
                </em>Engineer
                <em>
                    <span class="sr_only">&gt;</span>
                </em>Mobile SVC
                <em>
                    <span class="sr_only">&gt;</span>
                </em>Mobile SVC Request Status Detail (Other)
            </div>
            <!-- //breadcrumbs -->
            <!-- //contents_head -->
            <!-- Basic tit -->
            <div class="sub_tit">Basic</div>
            <!-- //Basic tit -->
            <!-- detail_Basic -->
            <table class="create_table">
                <colgroup>
                    <col width="13.5%" />
                    <col width="*" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>Name</th>
                        <td>{{name}}</td>
                    </tr>
                    <tr>
                        <th>English Name</th>
                        <td>{{engName}}</td>
                    </tr>
                    <!--
                    <tr>
                        <th>Cell Phone Number</th>
                        <td>{{cellPhoneNo}}</td>
                    </tr>
                    <tr>
                        <th>Office Phone Number</th>
                        <td>{{officePhoneNo}}</td>
                    </tr>
                    -->
                </tbody>
            </table>
            <div class="btn_wrap topLine"></div>
            <!-- //detail_Basic -->
            <!-- Information tit -->
            <div class="sub_tit mt40">Request Information</div>
            <!-- //Information tit -->
            <!-- detail_Information -->
            <table class="create_table">
                <colgroup>
                    <col width="13.5%" />
                    <col width="*" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>Request Type</th>
                        <td>{{reqType}}</td>
                    </tr>
                    <tr v-if="['003', '004'].includes(reqTypeCode)">
                        <th>ESN/IMEI Writing P/W</th>
                        <td>******************</td>
                    </tr>
                    <tr v-if="['006', '007'].includes(reqTypeCode)">
                        <th>Country</th>
                        <td>{{country}}</td>
                    </tr>
                    <tr v-if="['008'].includes(reqTypeCode)">
                        <th>User Role</th>
                        <td>{{role}}</td>
                    </tr>
                </tbody>
            </table>
            <div class="btn_wrap topLine">
                <a class="btn_white" @click="onListBtnClick">List</a>
            </div>
        </div>
    </div>
</template>

<script>
import Vue   from 'vue';
import axios from 'axios';
import { SDLUtil, DateUtil } from '@/utils';

import qs from 'query-string';

// if (type_cd == "004" || type_cd == "003") {
// 	$("#imeiPassHidden").show();
// } else if (type_cd == "006" || type_cd == "007") {
// 	$("#countryHidden").show();
// } else if (type_cd == "008") {
// 	$("#roleHidden").show();
// }

export default {
    name: 'hhp-request-other-view',

    props: {
        seqNo: { type: String, required: true },
        onBackToList: { type: Function, required: true },
    },
    computed: {},
    data() {
        return {
            name: '',
            engName: '',
            email: '',
            cellPhoneNo: '',
            officePhoneNo: '',
            country: '',
            reqType: '',
            reqTypeCode: '',
            role: '',
        };
    },
    created() {
        this.init();
    },
    mounted() {},
    methods: {
        async init() {
            SDLUtil.showLoadingBar(true);
            await this.fetchRequest(this.seqNo)
                .then(data => {
                    console.log('RequestOtherView', data);
                    this.setData(data);
                })
                .catch(err => {
                    Vue.$log.error(err);
                });
            SDLUtil.showLoadingBar(false);
        },

        fetchRequest(seqNo) {
            const params = {
                seq_no: seqNo,
            };

            return axios
                .get(`${SDLUtil.API_URL}/basis/anysvcmobile/request/RequestOtherView.skp`, { params })
                .then(res => {
                    if (res.data.row.length !== 1) {
                        return Promise.reject(
                            Object.assign(res, new Error('No data was found with the seqNo provided.')),
                        );
                    }
                    return res.data.row[0];
                })
                .catch(err => {
                    Vue.$log.error('RequestStatus Error', err);
                    return err;
                });
        },

        setData(data) {
            // ENAME: " "
            // EMAIL: " "
            // NAME: " "
            // REQ_TYPE: "Update the User Information"
            // COUNTRY: " "
            // TYPE_CD: " "
            // SEQ_NO:
            // PHONE_CELL_NO: "1234567"
            // PHONE_OFFICE_NO: "1234567"
            // REQ_ROLE: " "

            this.engName = data.ENAME;
            this.email = data.EMAIL;
            this.name = data.NAME;
            this.cellPhoneNo = data.PHONE_CELL_NO;
            this.officePhoneNo = data.PHONE_OFFICE_NO;
            this.country = data.COUNTRY;
            this.reqType = data.REQ_TYPE;
            this.reqTypeCode = data.TYPE_CD;
            this.role = data.REQ_ROLE;
        },

        onListBtnClick(event) {
            this.onBackToList();
        },
    },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/request/RequestOtherView.vue